import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _Promise from '/var/www/html/node_modules/babel-runtime/core-js/promise';
import _Object$defineProperty from '/var/www/html/node_modules/babel-runtime/core-js/object/define-property';
import _Object$assign from '/var/www/html/node_modules/babel-runtime/core-js/object/assign';
import _extends from '/var/www/html/node_modules/babel-runtime/helpers/extends';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';

var createApp = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ssrContext) {
    var _this = this;

    var router, app, next, route, path, inject;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            router = createRouter(ssrContext);

            // Create Root instance
            // here we inject the router and store to all child components,
            // making them available everywhere as `this.$router` and `this.$store`.

            app = _extends({
              router: router,

              nuxt: {
                defaultTransition: defaultTransition,
                transitions: [defaultTransition],
                setTransitions: function setTransitions(transitions) {
                  if (!Array.isArray(transitions)) {
                    transitions = [transitions];
                  }
                  transitions = transitions.map(function (transition) {
                    if (!transition) {
                      transition = defaultTransition;
                    } else if (typeof transition === 'string') {
                      transition = _Object$assign({}, defaultTransition, { name: transition });
                    } else {
                      transition = _Object$assign({}, defaultTransition, transition);
                    }
                    return transition;
                  });
                  this.$options.nuxt.transitions = transitions;
                  return transitions;
                },

                err: null,
                dateErr: null,
                error: function error(err) {
                  err = err || null;
                  app.context._errored = !!err;
                  if (typeof err === 'string') err = { statusCode: 500, message: err };
                  var nuxt = this.nuxt || this.$options.nuxt;
                  nuxt.dateErr = Date.now();
                  nuxt.err = err;
                  // Used in lib/server.js
                  if (ssrContext) ssrContext.nuxt.error = err;
                  return err;
                }
              }
            }, App);
            next = ssrContext ? ssrContext.next : function (location) {
              return app.router.push(location);
            };
            // Resolve route

            route = void 0;

            if (ssrContext) {
              route = router.resolve(ssrContext.url).route;
            } else {
              path = getLocation(router.options.base);

              route = router.resolve(path).route;
            }

            // Set context to app.context
            _context2.next = 7;
            return setContext(app, {
              route: route,
              next: next,
              error: app.nuxt.error.bind(app),

              payload: ssrContext ? ssrContext.payload : undefined,
              req: ssrContext ? ssrContext.req : undefined,
              res: ssrContext ? ssrContext.res : undefined,
              beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined
            });

          case 7:
            inject = function inject(key, value) {
              if (!key) throw new Error('inject(key, value) has no key provided');
              if (!value) throw new Error('inject(key, value) has no value provided');
              key = '$' + key;
              // Add into app
              app[key] = value;

              // Check if plugin not already installed
              var installKey = '__nuxt_' + key + '_installed__';
              if (Vue[installKey]) return;
              Vue[installKey] = true;
              // Call Vue.use() to install the plugin into vm
              Vue.use(function () {
                if (!Vue.prototype.hasOwnProperty(key)) {
                  _Object$defineProperty(Vue.prototype, key, {
                    get: function get() {
                      return this.$root.$options[key];
                    }
                  });
                }
              });
            };

            // Plugin execution

            if (!(typeof nuxt_plugin_website_4e45e11c === 'function')) {
              _context2.next = 11;
              break;
            }

            _context2.next = 11;
            return nuxt_plugin_website_4e45e11c(app.context, inject);

          case 11:
            if (!(typeof nuxt_plugin_veevalidate_1a0c1998 === 'function')) {
              _context2.next = 14;
              break;
            }

            _context2.next = 14;
            return nuxt_plugin_veevalidate_1a0c1998(app.context, inject);

          case 14:
            if (!(typeof nuxt_plugin_transinit_1f2bdd0c === 'function')) {
              _context2.next = 17;
              break;
            }

            _context2.next = 17;
            return nuxt_plugin_transinit_1f2bdd0c(app.context, inject);

          case 17:
            if (!(typeof nuxt_plugin_dcbabtest_4b4367b9 === 'function')) {
              _context2.next = 20;
              break;
            }

            _context2.next = 20;
            return nuxt_plugin_dcbabtest_4b4367b9(app.context, inject);

          case 20:
            if (!(typeof nuxt_plugin_searchhelper_96e97db0 === 'function')) {
              _context2.next = 23;
              break;
            }

            _context2.next = 23;
            return nuxt_plugin_searchhelper_96e97db0(app.context, inject);

          case 23:
            if (!process.browser) {
              _context2.next = 42;
              break;
            }

            if (!(typeof nuxt_plugin_langcheck_24114938 === 'function')) {
              _context2.next = 27;
              break;
            }

            _context2.next = 27;
            return nuxt_plugin_langcheck_24114938(app.context, inject);

          case 27:
            if (!(typeof nuxt_plugin_authinit_05eaa390 === 'function')) {
              _context2.next = 30;
              break;
            }

            _context2.next = 30;
            return nuxt_plugin_authinit_05eaa390(app.context, inject);

          case 30:
            if (!(typeof nuxt_plugin_trackingcodelib_74b18f92 === 'function')) {
              _context2.next = 33;
              break;
            }

            _context2.next = 33;
            return nuxt_plugin_trackingcodelib_74b18f92(app.context, inject);

          case 33:
            if (!(typeof nuxt_plugin_activitylogger_cdbdd9c2 === 'function')) {
              _context2.next = 36;
              break;
            }

            _context2.next = 36;
            return nuxt_plugin_activitylogger_cdbdd9c2(app.context, inject);

          case 36:
            if (!(typeof nuxt_plugin_globalerrorhandler_85522ff4 === 'function')) {
              _context2.next = 39;
              break;
            }

            _context2.next = 39;
            return nuxt_plugin_globalerrorhandler_85522ff4(app.context, inject);

          case 39:
            if (!(typeof nuxt_plugin_sessionlocalstorage_984d6dea === 'function')) {
              _context2.next = 42;
              break;
            }

            _context2.next = 42;
            return nuxt_plugin_sessionlocalstorage_984d6dea(app.context, inject);

          case 42:
            if (!(process.server && ssrContext && ssrContext.url)) {
              _context2.next = 45;
              break;
            }

            _context2.next = 45;
            return new _Promise(function (resolve, reject) {
              router.push(ssrContext.url, resolve, function () {
                // navigated to a different route in router guard
                var unregister = router.afterEach(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            ssrContext.url = to.fullPath;
                            _context.next = 3;
                            return getRouteData(to);

                          case 3:
                            app.context.route = _context.sent;

                            app.context.params = to.params || {};
                            app.context.query = to.query || {};
                            unregister();
                            resolve();

                          case 8:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2, _x3, _x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              });
            });

          case 45:
            return _context2.abrupt('return', {
              app: app,
              router: router

            });

          case 46:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function createApp(_x) {
    return _ref.apply(this, arguments);
  };
}();

import 'es6-promise/auto';
import Vue from 'vue';
import Meta from 'vue-meta';
import { createRouter } from './router.js';
import NoSSR from './components/no-ssr.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtLink from './components/nuxt-link.js';
import NuxtError from './components/nuxt-error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData } from './utils';

/* Plugins */
import nuxt_plugin_website_4e45e11c from 'nuxt_plugin_website_4e45e11c'; // Source: ../plugins/website.js
import nuxt_plugin_langcheck_24114938 from 'nuxt_plugin_langcheck_24114938'; // Source: ../plugins/lang-check.js (ssr: false)
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998'; // Source: ../plugins/vee-validate.js
import nuxt_plugin_transinit_1f2bdd0c from 'nuxt_plugin_transinit_1f2bdd0c'; // Source: ../plugins/trans-init.js
import nuxt_plugin_authinit_05eaa390 from 'nuxt_plugin_authinit_05eaa390'; // Source: ../plugins/auth-init.js (ssr: false)
import nuxt_plugin_trackingcodelib_74b18f92 from 'nuxt_plugin_trackingcodelib_74b18f92'; // Source: ../plugins/tracking-code-lib.js (ssr: false)
import nuxt_plugin_activitylogger_cdbdd9c2 from 'nuxt_plugin_activitylogger_cdbdd9c2'; // Source: ../plugins/activity-logger.js (ssr: false)
import nuxt_plugin_dcbabtest_4b4367b9 from 'nuxt_plugin_dcbabtest_4b4367b9'; // Source: ../plugins/dcb-ab-test.js
import nuxt_plugin_globalerrorhandler_85522ff4 from 'nuxt_plugin_globalerrorhandler_85522ff4'; // Source: ../plugins/global-error-handler.js (ssr: false)
import nuxt_plugin_sessionlocalstorage_984d6dea from 'nuxt_plugin_sessionlocalstorage_984d6dea'; // Source: ../plugins/session-local-storage.js (ssr: false)
import nuxt_plugin_searchhelper_96e97db0 from 'nuxt_plugin_searchhelper_96e97db0'; // Source: ../plugins/search_helper.js


// Component: <no-ssr>
Vue.component(NoSSR.name, NoSSR);

// Component: <nuxt-child>
Vue.component(NuxtChild.name, NuxtChild);

// Component: <nuxt-link>
Vue.component(NuxtLink.name, NuxtLink);

// Component: <nuxt>`
Vue.component(Nuxt.name, Nuxt);

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
});

var defaultTransition = { "name": "page", "mode": "out-in", "appear": false, "appearClass": "appear", "appearActiveClass": "appear-active", "appearToClass": "appear-to" };

export { createApp, NuxtError };


//////////////////
// WEBPACK FOOTER
// ./.nuxt/index.js
// module id = ./.nuxt/index.js
// module chunks = 54